import React from 'react';
import { FieldArray } from 'formik';
import styled from 'styled-components';

import { ButtonPrimary } from '@yuhu-inc/yuhui';
import AdditionalField from './AdditionalField';

import { getTranslatedString } from 'helpers/i18n';

import { StyledFooterText } from './shared_styles/footers';

const StyledBodyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButtonContainerFieldView = styled.div`
  align-self: ${(props) => (props.center ? 'center' : 'flex-start')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '30px')};
`;

const StyledButton = styled(ButtonPrimary)`
  min-width: 140px;
  font-size: 18px !important;
`;

const AdditionalFields = ({
  values,
  setFieldValue,
  errors,
  handleRemoveField,
  documentTemplateTitle,
}) => {
  return (
    <React.Fragment>
      <FieldArray
        name="additional_fields"
        render={(arrayHelpers) => {
          return (
            <React.Fragment>
              <StyledBodyContainer>
                {values.additional_fields.map((additionalField, index) => {
                  return (
                    <AdditionalField
                      additionalField={additionalField}
                      values={values}
                      setFieldValue={setFieldValue}
                      index={index}
                      errors={errors}
                      handleRemoveField={handleRemoveField}
                      documentTemplateTitle={documentTemplateTitle}
                    />
                  );
                })}
              </StyledBodyContainer>
              <StyledButtonContainerFieldView>
                <StyledButton
                  type="button"
                  contentKey="landlordPortal.documentTemplate.addField"
                  onClick={() => {
                    arrayHelpers.push({
                      label: '',
                      field_type: 'text',
                      default_value: '',
                    });
                  }}
                />
              </StyledButtonContainerFieldView>
            </React.Fragment>
          );
        }}
      />
      <StyledButtonContainerFieldView center marginTop="177px">
        <StyledButton contentKey="landlordPortal.inspections.next" />
      </StyledButtonContainerFieldView>
      <StyledFooterText>
        {getTranslatedString('landlordPortal.documentTemplate.completedPagesAutoSave')}
      </StyledFooterText>
    </React.Fragment>
  );
};

export default AdditionalFields;
